var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74991 11.2629C8.74991 11.6771 8.41412 12.0129 7.99991 12.0129C7.58569 12.0129 7.24991 11.6771 7.24991 11.2629C7.24991 10.8487 7.58569 10.5129 7.99991 10.5129C8.41412 10.5129 8.74991 10.8487 8.74991 11.2629Z",
    fill: "#FF7A05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60672 6.00592C8.60672 5.66074 8.3269 5.38092 7.98172 5.38092C7.63654 5.38092 7.35672 5.66074 7.35672 6.00592V9.02935C7.35672 9.37453 7.63654 9.65435 7.98172 9.65435C8.3269 9.65435 8.60672 9.37453 8.60672 9.02935L8.60672 6.00592Z",
    fill: "#FF7A05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24044 1.46974C7.57646 0.882482 8.42335 0.88248 8.75937 1.46974L15.3283 12.9502C15.6621 13.5336 15.2409 14.2598 14.5688 14.2598L1.43098 14.2598C0.758919 14.2598 0.337746 13.5336 0.671516 12.9502L7.24044 1.46974ZM7.99991 2.65938L2.0776 13.0098L13.9222 13.0098L7.99991 2.65938Z",
    fill: "#FF7A05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarning);
export default __webpack_public_path__ + "static/media/alert-warning.15081e0da5b82cb7fd07a86e17338e8d.svg";
export { ForwardRef as ReactComponent };